import React, { useEffect, useState } from 'react';
import { ContractorModel } from '../../models';
import { ContractorsAPI } from '../../services/external/APIs';

/**
 * Dependiendo del tipo de contratista obtenemos los contratos
 * @param typeOfPerson string
 * @returns ContractorModel[]
 */
export const UseGetContractorsList = (typeOfPerson: string) => {
    const [contractorsList, setContractorsList] = useState<ContractorModel[]>([]);

    useEffect(() => {
        ContractorsAPI.getContractors().then((res) => {
            setContractorsList(res);
        });
    }, [typeOfPerson]);

    return {
        contractorsList,
    };
};
